export const getSelectedCostOfExtras = (tiers: any) => {
  return tiers.filter((tier: any) => tier?.selected).map((tier: any) => tier?.amountInPounds)[0]
}
